export const getBerlinDate = (date: Date, daysBeforeDate?: number) => {
  const germanDateFormatter = new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    timeZone: "Europe/Berlin"
  });

  const [
    { value: initialMonth },
    ,
    { value: initialDay },
    ,
    { value: initialYear }
  ] = germanDateFormatter.formatToParts(date);

  const localisedDate = new Date(
    Date.UTC(Number(initialYear), Number(initialMonth) - 1, Number(initialDay))
  );

  if (daysBeforeDate) {
    localisedDate.setDate(localisedDate.getDate() - daysBeforeDate);
  }

  const [{ value: finalMonth }, , { value: finalDay }, , { value: finalYear }] =
    germanDateFormatter.formatToParts(localisedDate);

  return `${finalYear}${finalMonth}${finalDay}`;
};
